import React from 'react'
import { Modal, ModalVariant } from '@at/design-system-patterns'
import { SaveSearchForm } from './save-search-form'
import { SessionExpiredModal } from '../../session-expired/session-expired-modal'
import { useUserState } from '@at/connected-signin'

interface SaveSearchModalProps {
    handleHideModal: () => void
}

export const SaveSearchModal = ({ handleHideModal }: SaveSearchModalProps) => {
    const [userState] = useUserState()
    return (
        <>
            {!userState.userSignedIn ? (
                <SessionExpiredModal handleHideModal={handleHideModal} />
            ) : (
                <Modal
                    isShowing={true}
                    closeText={'Close'}
                    hideFn={() => handleHideModal()}
                    variation={ModalVariant.MAX}
                    hasBackLink={true}
                    focusId="modal-button"
                >
                    <SaveSearchForm handleHideModal={handleHideModal} />
                </Modal>
            )}
        </>
    )
}
